<template>
    <v-popover trigger="click"
               :placement="placement"
               :popoverClass="popoverClass"
               popoverInnerClass="tooltip-inner"
               popoverBaseClass="vueTooltip ClosableTooltip__tooltip"
               popoverArrowClass="tooltip-arrow"
               :open.sync="open">
        <IconBase
            :width="iconWidth"
            :height="iconHeight"
            :iconColor="consts.COLORS.LIGHT_700"
            :iconName="icon"
            @click.stop.prevent.native="open = true"/>
      <template slot="popover">
        <span class="close-button-wrapper" v-if="showCloseButton">
              <span class="close-button" @click="open = false">
                  <IconBase icon-name="closeIcon"
                            class="close-icon"
                            :icon-color="closeIcon.color"
                            :width="closeIcon.size"
                            :height="closeIcon.size"
                            v-once></IconBase>
              </span>
        </span>
        <slot>
            <span>{{text}}</span>
        </slot>
      </template>
    </v-popover>
</template>

<script>

import consts from 'services/metaData/consts';
import IconBase from 'components/IconBase.vue';
import tooltipConsts from './consts';

export default {
    name: 'ClosableTooltip',
    components: { IconBase },
    data() {
        return {
            consts,
            open: false,
            closeIcon: {
                color: consts.$white,
                size: '8px'
            }
        };
    },
    props: {
        placement: {
            type: String,
            default: 'bottom',
            validator: (val) => tooltipConsts.TOOLTIP_POSITIONS.includes(val)
        },
        showCloseButton: {
            type: Boolean,
            default: true
        },
        popoverClass: String,
        text: String,
        icon: {
            type: String,
            default: 'infoTooltipIcon'
        },
        iconHeight: {
            type: [String, Number],
            default: 12
        },
        iconWidth: {
            type: [String, Number],
            default: 12
        },
    }
};
</script>

<style lang="scss">
/* Needs to be global since v-poopover appends to body */
  .ClosableTooltip__tooltip {
    width: 200px;
  }
</style>

<style scoped lang="scss">
  @import './tooltip.css';
  @import "~styles/styleGuide";


  .close-button-wrapper {
    float: right;
    cursor: pointer;
    transform: translateY(-5px);
  }

</style>
